module.exports = ".loan_list >  div{\r\n\tborder-bottom-color: transparent;\r\n\tpadding-bottom: 25px;\r\n\tmargin-bottom: 0 !important;\r\n}"